export const Breadcrumb = `
    const [paths] = React.useState([
        {
            url: '#',
            label: 'link 1'
        },
        {
            url: '#',
            label: 'Link 2',
        },
        {
            url: '#',
            label: 'Link 3',
        }
    ])

    <Breadcrumb 
        paths={paths} // Array: [{url, label, id}]
        className="custom-class" // String
    />

`
